// @flow
import Typography from "typography"; // eslint-disable-line import/no-extraneous-dependencies

const typography = new Typography({
  baseFontSize: "16px",
  baseLineHeight: 1.5,
  headerFontFamily: [
    "AvenirNext",
    "HelveticaNeue-Light",
    "Helvetica Neue Light",
    "Helvetica Neue",
    "Helvetica",
    "Arial",
    "Lucida Grande",
    "sans-serif"
  ],
  bodyFontFamily: [
    "AvenirNext",
    "HelveticaNeue-Light",
    "Helvetica Neue Light",
    "Helvetica Neue",
    "Helvetica",
    "Arial",
    "Lucida Grande",
    "sans-serif"
  ],
  bodyColor: "#000000",
  headerWeight: 700,
  bodyWeight: 400,
  boldWeight: 700
  // overrideStyles: ({ adjustFontSizeTo, rhythm }, options, styles) => {
  //   return {
  //     h1: {
  //       ...adjustFontSizeTo("48px"),
  //     },
  //     h2: {
  //       ...adjustFontSizeTo("40px"),
  //     },
  //     h3: {
  //       ...adjustFontSizeTo("32px"),
  //     },
  //     h4: {
  //       ...adjustFontSizeTo("24px"),
  //     },
  //     h5: {
  //       ...adjustFontSizeTo("20px"),
  //     },
  //     "h1,h2,h3,h4,h5,h6": {
  //       lineHeight: 1.125,
  //     },
  //     "h3,h4,h5,h6": {
  //       fontFamily: options.bodyFontFamily.join(","),
  //       fontWeight: 800,
  //     },
  //   }
  // },
});

module.exports = typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js